export enum AuthenticationStatus {
  UNKNOWN = 'unknown',
  AUTHENTICATED = 'authenticated',
  GUEST = 'guest',
}
